export default function useMediaMentionsAccess() {
  return true
}
